// ANAMNESIS — theme interactions
document.addEventListener('DOMContentLoaded', function () {

  /* ---- Header scroll state ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile nav ---- */
  var burger = document.querySelector('.site-header__burger');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileClose = document.querySelector('.mobile-nav__close');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () { mobileNav.classList.add('is-open'); });
    mobileClose && mobileClose.addEventListener('click', function () { mobileNav.classList.remove('is-open'); });
  }

  /* ---- Cart drawer ---- */
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-overlay');
  var cartTriggers = document.querySelectorAll('[data-cart-open]');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
  }
  cartTriggers.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* ---- Archive product: swatch + size selection, gallery thumbs ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var swatches = form.querySelectorAll('.swatch');
    var sizes = form.querySelectorAll('.size-pill:not([disabled])');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var variantInput = form.querySelector('[data-variant-id]');
    var selectedColor = null;
    var selectedSize = null;

    function refreshAddState() {
      if (!addBtn) return;
      var ready = (!swatches.length || selectedColor) && (!sizes.length || selectedSize);
      addBtn.disabled = !ready;
      addBtn.textContent = ready ? 'Add to Cart' : 'Select Options';
    }

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        swatches.forEach(function (o) { o.classList.remove('is-selected'); });
        s.classList.add('is-selected');
        selectedColor = s.dataset.value;
        refreshAddState();
      });
    });

    sizes.forEach(function (s) {
      s.addEventListener('click', function () {
        sizes.forEach(function (o) { o.classList.remove('is-selected'); });
        s.classList.add('is-selected');
        selectedSize = s.dataset.value;
        refreshAddState();
      });
    });

    refreshAddState();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      var id = variantInput ? variantInput.value : null;
      if (!id) return;

      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          addBtn.textContent = 'Added';
          openCart();
          setTimeout(refreshAddState, 1600);
        })
        .catch(function () {
          addBtn.textContent = 'Error — try again';
        });
    });
  });

  /* ---- Gallery thumbs swap main image ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (main && t.dataset.full) { main.src = t.dataset.full; }
      });
    });
  });
});
